const debug = false;
let metaPixelId = "1122566793216536"; // DEV Pixel
let measurementId = "G-E6E3YXV4LQ"; // DEV measurementId
if (!BDAY_ENV || BDAY_ENV === "prod") {
  metaPixelId = "1140129487898624"; // PROD Pixel
  measurementId = "G-WDFGPQWS3E"; // PROD measurementId
} else if (BDAY_ENV === "nick") {
  measurementId = "G-SW24KEE9P5"; // NICK measurementId
}
const baseUrl = `https://${BDAY_ENV !== "prod" ? `${BDAY_ENV}.` : ""}birthdayalarm.com`;

const eventMappings = {
  // E-commerce events
  _Purchase_: {
    bday: "purchase",
    ga4: "purchase",
    meta: "Purchase",
  },
  _AddToCart_: {
    bday: "add_to_cart",
    ga4: "add_to_cart",
    meta: "AddToCart",
  },
  _ViewCart_: {
    bday: "view_cart",
    ga4: "view_cart",
    meta: "ViewCart",
  },
  _RemoveFromCart_: {
    bday: "remove_from_cart",
    ga4: "remove_from_cart",
    meta: "RemoveFromCart",
  },
  _BeginCheckout_: {
    bday: "begin_checkout",
    ga4: "begin_checkout",
    meta: "InitiateCheckout",
  },
  _AddPaymentInfo_: {
    bday: "add_payment_info",
    ga4: "add_payment_info",
    meta: "AddPaymentInfo",
  },
  _AddShippingInfo_: {
    bday: "view_deliver_step",
    ga4: "add_shipping_info",
    meta: "AddShippingInfo",
  },
  _ViewItem_: {
    bday: "view_item",
    ga4: "view_item",
    meta: "ViewContent",
  },
  _ViewItemList_: {
    bday: "view_item_list",
    ga4: "view_item_list",
    meta: "ViewContent",
  },
  _SelectItem_: {
    bday: "select_item",
    ga4: "select_item",
    meta: "SelectItem",
  },
  _Search_: {
    bday: "search",
    ga4: "search",
    meta: "Search",
  },
  // User engagement events
  _Register_: {
    bday: "register",
    ga4: "sign_up",
    meta: "CompleteRegistration",
  },
  _Login_: {
    bday: "login",
    ga4: "login",
    meta: "Lead", // Meta doesn't have a "Login" event, "Lead" can be a proxy
  },
  _Subscribe_: {
    bday: "subscribe",
    ga4: "subscribe",
    meta: "Subscribe",
  },
  _Contact_: {
    bday: "contact",
    ga4: "contact",
    meta: "Contact",
  },
  // Auth Source Tracking
  LOGIN_BDAY: {
    bday: "signed_with_email",
    ga4: "signed_with_email",
    meta: "signed_with_email",
  },
  LOGIN_GOOGLE: {
    bday: "signed_with_google",
    ga4: "signed_with_google",
    meta: "signed_with_google",
  },
  LOGIN_FACEBOOK: {
    bday: "signed_with_facebook",
    ga4: "signed_with_facebook",
    meta: "signed_with_facebook",
  },
  LOGIN_APPLE: {
    bday: "signed_with_apple",
    ga4: "signed_with_apple",
    meta: "signed_with_apple",
  },
  REGISTER_BDAY: {
    bday: "registered_with_email",
    ga4: "registered_with_email",
    meta: "registered_with_email",
  },
  REGISTER_FACEBOOK: {
    bday: "registered_with_facebook",
    ga4: "registered_with_facebook",
    meta: "registered_with_facebook",
  },
  REGISTER_APPLE: {
    bday: "registered_with_apple",
    ga4: "registered_with_apple",
    meta: "registered_with_apple",
  },
};

const config = { debug, baseUrl, metaPixelId, measurementId, eventMappings };
export default config;
